// extracted by mini-css-extract-plugin
export var accordionIcon = "style-mod--accordion-icon--91376";
export var categoryTitle = "style-mod--category-title--419f7";
export var checkmark = "style-mod--checkmark--7cf49";
export var highlightedColumn = "style-mod--highlighted-column--9b6a2";
export var icon = "style-mod--icon--b9320";
export var learnMore = "style-mod--learn-more--dfa12";
export var mainTitleBox = "style-mod--main-title-box--833cb";
export var mainTitleBoxMobile = "style-mod--main-title-box-mobile--14171";
export var open = "style-mod--open--b1cf8";
export var priceDescription = "style-mod--price-description--86ba3";
export var prodAllBorders = "style-mod--prod-all-borders--00542";
export var prodBlueBox = "style-mod--prod-blue-box--addc2";
export var prodBox = "style-mod--prod-box--7727a";
export var prodCategoryTitle = "style-mod--prod-category-title--6515f";
export var prodContent = "style-mod--prod-content--6cc79";
export var prodContentBlock = "style-mod--prod-content-block--d99dc";
export var prodImg = "style-mod--prod-img--3daa0";
export var prodMainImg = "style-mod--prod-main-img--7e226";
export var prodMainImgMobile = "style-mod--prod-main-img-mobile--d9540";
export var prodMoney = "style-mod--prod-money--21359";
export var prodSubtitle = "style-mod--prod-subtitle--5e9d5";
export var prodSubtitleBold = "style-mod--prod-subtitle-bold--8a1e3";
export var prodTitle = "style-mod--prod-title--59781";
export var productBoxMobile = "style-mod--product-box-mobile--e476f";
export var productContainer = "style-mod--product-container--8a2df";
export var productContainerAllBorders = "style-mod--product-container-all-borders--76fec";
export var productContent = "style-mod--product-content--bfe1a";
export var productDetails = "style-mod--product-details--8b728";
export var productDetailsContent = "style-mod--product-details-content--f636a";
export var productDetailsContentAllBorders = "style-mod--product-details-content-all-borders--5df4f";
export var reviewTitleSubtitle = "style-mod--review-title-subtitle--ec38a";
export var roundedCornersImg = "style-mod--rounded-corners-img--53221";
export var sectionTitle = "style-mod--section-title--57377";
export var tableProductInformation = "style-mod--table-product-information--50ed0";
export var tableProductInformationDesktop = "style-mod--table-product-information-desktop--3c908";
export var tableProductInformationMobile = "style-mod--table-product-information-mobile--77cf7";
export var title = "style-mod--title--97694";
export var titleContent = "style-mod--title-content--bc5cc";